// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.2.0';
export const APP_NAME = 'markwins';
export const FILE_HASH = '1771434343675';
export const BUILD_DATE = '2026-02-18T17:05:43.675Z';
/* tslint:enable */
